// @flow
import type { RouterHistory } from "react-router";
import { withRouter } from "react-router";

import React, { Component } from "react";
import { compose } from "react-apollo";
import ReactGA from "react-ga";

import type {
  createUserType,
  signinUserType,
  userQueryResult,
  authUpdateType,
  Credentials
} from "../../data/accounts";

import {
  withCreateUser,
  withSigninUser,
  withAuthUpdate
} from "../../data/accounts";

import EmailPasswordForm from "../../components/EmailPasswordForm/EmailPasswordForm";
import WithLoadingIndicator from "../../components/WithLoadingIndicator/WithLoadingIndicator";
import Page from "../../components/Page/Page";
import WithTracker from "../../components/WithTracker/WithTracker";

// TODO: Readd static typing.
// Error: "Call of method `authUpdate`.
// Method cannot be called on any member of intersection type this.props"

// type Props = Object;
type Props = {
  authUpdate: authUpdateType,
  createUser: createUserType,
  signinUser: signinUserType,
  history: RouterHistory,
  authType: string
} & userQueryResult;

class SignupUser extends Component<Props> {
  createUser = ({ email, password }: Credentials) => {
    const userParams = { variables: { email, password } };
    const onError = e => {
      console.error(e);
      alert(
        "Couldn't create your account at this time, please try again later"
      ); // TODO - redirect to error page
      throw e;
    };
    this.props
      .createUser(userParams)
      .then(response => {
        this.props
          .signinUser(userParams)
          .then(response => {
            console.log("Signed in user");
            window.localStorage.setItem(
              "graphcoolToken",
              response.data.signinUser.token
            );
            this.props.history.push("/");
            this.props.userData.refetch();
          })
          .catch(onError);
      })
      .catch(onError);
  };

  showFailureAlert = e => {
    // TODO - redirect to error page
    alert("Couldn't create your account at this time, please try again later");
  };

  addLoginToAccount = ({ email, password }: Credentials) => {
    ReactGA.event({ category: "Auth", action: "Add Login" });
    const user = this.props.userData.user;
    if (!user) {
      this.showFailureAlert();
      throw new Error("Account creation failed (no auto-login)");
    }
    const { id } = user;
    const onError = e => {
      console.error(e);
      this.showFailureAlert();
    };

    this.props
      .authUpdate({
        variables: {
          id,
          email,
          password
        }
      })
      .then(response => {
        this.props.userData.refetch();
        this.props.history.push("/");
      })
      .catch(onError);
  };

  render() {
    return (
      <Page className="SignupUser" title={"Sign up"}>
        <p>Your responses so far will be saved to your new account. </p>
        <EmailPasswordForm
          onSubmit={this.addLoginToAccount}
          submitButtonLabel={"Sign up"}
        />
      </Page>
    );
  }
}

const extendComponent = compose(
  WithTracker,
  withAuthUpdate,
  withCreateUser,
  withSigninUser,
  withRouter,
  WithLoadingIndicator
);

export default extendComponent(SignupUser);



// WEBPACK FOOTER //
// ./src/pages/SignupUser/SignupUser.js